<template>
  <Modal ref="modal" title="" :closeIconShown="false" :force="true">
    <div class="modal-container">
      <CheckCircle class="icon" :size="116" />

      <div class="content">
        <h3>Aulas agendadas com sucesso!</h3>

        <p>Para mais detalhes acesse o submenu <a @click="redirect"><span>aulas agendadas</span></a>.</p>

        <Button class="button" @handle:click="confirm" text="Ok, continuar" color="primary" />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '../core/Modal'
import Button from '../core/Button'
import CheckCircle from 'icons/CheckCircle'

export default {
  name: 'OnSuccessModal',
  components: {
    Modal,
    Button,
    CheckCircle,
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    redirect() {
      this.$router.push({ name: 'aulas-agendadas' })
    },
    confirm() {
      this.$emit('confirm', 'ok')
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-container {
  max-width: 33.8125rem;
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  gap: 2.0625rem;

  .icon {
    color: #1C2D5A;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    h3,
    p {
      margin: 0;
    }

    h3 {
      font-size: 1.5rem;
      font-weight: 700;
      color: #202224;
    }

    p {
      font-size: 1rem;
      font-weight: 500;
      color: #606264;

      span {
        font-size: 1rem;
        font-weight: 600;
        color: #1C2D5A;
      }
    }

    .button {
      text-align: center;
    }
  }
}
</style>